// Forwards the 3D map editor's statusMessage (set throughout mapEditorStore -
// "Placed X.", "Undo: ...", "Unknown asset: ...", etc.) to the app's real
// toast host. Previously this field was only ever read by MapEditorOverlay,
// which this app doesn't render (Studio's own Edit mode uses chrome='viewport',
// not MapEditorOverlay's chrome='full' - see useEditorShortcuts.ts for why
// that export still exists), so every one of these messages was invisible in
// the shipped editor. Mount once per editor session.
import { useEffect } from 'react';

import { useMapEditorStore } from '../../engine/editor/store/mapEditorStore';
import { useToast } from '../design/toast';

export function useMapEditorToastBridge(): void {
  const statusMessage = useMapEditorStore((state) => state.statusMessage);
  const saveState = useMapEditorStore((state) => state.saveState);
  const clearStatus = useMapEditorStore((state) => state.clearStatus);
  const notify = useToast();

  useEffect(() => {
    if (!statusMessage) return;
    notify(statusMessage, saveState === 'error' ? 'error' : 'info');
    clearStatus();
  }, [statusMessage, saveState, clearStatus, notify]);
}
